module.exports = __webpack_public_path__ + "static/media/LATMALCOTKITX1.f623b5e9.png";